/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { memo, ReactElement } from 'react';
import { TableHead } from '@mui/material';
import { Order } from '../../../data/api/apiCommon.typings';
import { ListTableColumnConfig } from './ListTypes';
import ListTableHeadContent from './ListTableHeadContent';

interface ListTableHeadProps<T extends object> {
    columns: ListTableColumnConfig<T>[];
    stateSortParam: string;
    sortingCallback(order: Order, keyForValue: keyof T): void;
    getCustomCellContent?(index: number, columnKey: string): ReactElement;
}

const ListTableHead = <T extends object>(props: ListTableHeadProps<T>) => {
    const { columns, stateSortParam, sortingCallback, getCustomCellContent } = props;

    return (
        <TableHead>
            <ListTableHeadContent
                columns={columns as ListTableColumnConfig<object>[]}
                sortingCallback={sortingCallback}
                stateSortParam={stateSortParam}
                getCustomCellContent={getCustomCellContent}
            />
        </TableHead>
    );
};

export default memo(ListTableHead);
